import { put, select } from "redux-saga/effects";
import { fetchProductList, fetchProducts } from "./api";
import { catalogActions } from "./index";
import { listErrorTypes } from "pages/catalog/Catalog.container";
import { isItemShouldHaveMockImage } from "../../shared/lib/REMOVE.utils";

export function* updateCurrentItemsWithPageSize({ payload }) {
  const state = yield select();
  const { allItems, pageSize } = state.catalog;

  const { curPage, storeKey } = payload;

  if (allItems) {
    const productsWithPrices = allItems.reduce((acc, productWithPrices) => {
      return productWithPrices?.product?.code
        ? [
            ...acc,
            {
              ...productWithPrices,
              // @TODO REMOVE THIS LOGIC AFTER DEMO!
              image: isItemShouldHaveMockImage(productWithPrices.product.code)
                ? `/images/demoReplaceImages/${productWithPrices.product.code}.png`
                : `/api/v2/catalog/all/images/by-code/${productWithPrices.product.code}`,
            },
          ]
        : acc;
    }, []);

    const currentItems = productsWithPrices.slice(
      (curPage - 1) * pageSize,
      (curPage - 1) * pageSize + pageSize
    );

    yield put(
      catalogActions.addItems({
        items: currentItems,
        key: storeKey,
      })
    );
  }
}

export function* requestProductsWithPrices({ payload }) {
  try {
    const state = yield select();
    const { pageSize, catalogFilters } = state.catalog;
    const { current } = state.currency;

    const updatedFiltersPayload = { ...catalogFilters };

    if (updatedFiltersPayload.location === "All") {
      delete updatedFiltersPayload.location;
    }

    const similarity = updatedFiltersPayload.similarity;
    delete updatedFiltersPayload.sstype;
    delete updatedFiltersPayload.similarity;

    const {
      code,
      type,
      sstype,
      cat,
      inclusions,
      storeKey,
      setNothingFound,
      curPage,
      setTotal,
      searchBy,
    } = payload;

    yield put(catalogActions.setLoadingItems(true));
    setNothingFound(false);

    const result = yield fetchProducts({
      code,
      type,
      cat,
      sstype,
      inclusions,
      curPage,
      pageSize,
      searchBy,
      currency: current,
      catalogFilters: updatedFiltersPayload,
      similarity,
    });

    // @TODO Probably we have to move this mapper to separate logic
    let searchResultsWithInclusions;

    if (inclusions !== null) {
      searchResultsWithInclusions = [
        ...result.searchResults,
        // @TODO Use reduce instead of map
        ...result.searchResults.map((searchItem: any) =>
          searchItem?.included?.forms
            ?.filter((includedItem) =>
              includedItem?.inclusion?.details?.includes(
                "SALT_FORMS_AND_TAUTOMERS"
              )
            )
            .map((filteredIncludedItem) => ({
              ...filteredIncludedItem,
              inclusion: {
                ...filteredIncludedItem.inclusion,
                bindWith: searchItem.product.code,
              },
            }))
        ),
      ].flat();
    }

    const fetchedItems =
      searchResultsWithInclusions ?? result.searchResults ?? [];
    const total =
      searchResultsWithInclusions?.length ?? result.searchResultQuantity ?? 0;

    const productsWithPrices = fetchedItems.reduce((acc, productWithPrices) => {
      return productWithPrices?.product?.code
        ? [
            ...acc,
            {
              ...productWithPrices,
              // @TODO REMOVE THIS LOGIC AFTER DEMO!
              image: isItemShouldHaveMockImage(productWithPrices.product.code)
                ? `/images/demoReplaceImages/${productWithPrices.product.code}.png`
                : `/api/v2/catalog/all/images/by-code/${productWithPrices.product.code}`,
            },
          ]
        : acc;
    }, []);

    setTotal(total);

    const currentItems = productsWithPrices.slice(
      (curPage - 1) * pageSize,
      (curPage - 1) * pageSize + pageSize
    );

    if (productsWithPrices?.length === 0 || !productsWithPrices) {
      setNothingFound(true);
    } else {
      setNothingFound(false);
    }

    yield put(
      catalogActions.addItems({
        items: currentItems,
        allItems: productsWithPrices,
        key: storeKey,
      })
    );
    yield put(catalogActions.setLoadingItems(false));
  } catch (e) {
    console.log("Something went wrong!", e);
  }
}

export function* getProductList({ payload }) {
  try {
    const state = yield select();

    const {
      id,
      storeKey,
      setQ,
      setListName,
      setListErrorType,
      curPage,
      pageSize,
      setTotal,
    } = payload;

    const fullList = state.catalog.productLists?.[id];
    let result = [null, null];

    if (fullList) {
      result[0] = fullList;
    } else {
      result = yield fetchProductList({ id });
    }

    if (result[0]) {
      setQ(result[0].codes.toString());
      setListName(result[0].name);

      const productsWithPrices = result[0]?.products.reduce(
        (acc, productWithPrices) => {
          return productWithPrices?.product?.code
            ? [
                ...acc,
                {
                  ...productWithPrices,
                  // @TODO REMOVE THIS LOGIC AFTER DEMO!
                  image: isItemShouldHaveMockImage(
                    productWithPrices.product.code
                  )
                    ? `/images/demoReplaceImages/${productWithPrices.product.code}.png`
                    : `/api/v2/catalog/all/images/by-code/${productWithPrices.product.code}`,
                },
              ]
            : acc;
        },
        []
      );

      setTotal(productsWithPrices);

      setTotal(productsWithPrices?.length);

      yield put(
        catalogActions.setProductList({
          id,
          name: result[0].name,
          codes: result[0].codes,
          products: productsWithPrices,
        })
      );

      const currentItems = productsWithPrices.slice(
        (curPage - 1) * pageSize,
        (curPage - 1) * pageSize + pageSize
      );

      yield put(
        catalogActions.addItems({
          items: currentItems,
          allItems: productsWithPrices,
          key: storeKey,
        })
      );

      yield put(catalogActions.setLoadingItems(false));
    } else {
      if (result[2] === 400) {
        setListErrorType(listErrorTypes.DISABLED);
      } else if (result[2] === 404) {
        setListErrorType(listErrorTypes.NOT_FOUND);
      }

      yield put(catalogActions.setLoadingItems(false));
    }
  } catch (e) {
    console.log("Something went wrong!", e);
  }
}
